var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("h2", { staticClass: "mb-0" }, [
        _vm._v("Encontre um profissional de limpeza na sua cidade.")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Contrate limpezas por hora, com produtos de limpeza inclusos e com profissionais autônomos, avaliados e com referências."
        )
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "btn btn-pink",
          attrs: { to: { name: "purchase-flow" } }
        },
        [_vm._v("saiba mais")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7114ab2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7114ab2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderHistory/NoOrders.vue
// module id = null
// module chunks = 